import { PageHeader } from "src/general_components/PageHeader";

/**
 * Wrapper de compatibilidad hacia atrás.
 * Todos los usos existentes de <HeaderTitleBreadcrumbs listName="..." />
 * siguen funcionando sin cambios.
 *
 * También acepta las props extendidas de PageHeader:
 *   subtitle, icon, actions, loading
 */
export const HeaderTitleBreadcrumbs = ({
  listName,
  subtitle,
  icon,
  actions,
  loading,
  sx,
}) => {
  return (
    <PageHeader
      title={listName}
      subtitle={subtitle}
      icon={icon}
      actions={actions}
      loading={loading}
      sx={sx}
    />
  );
};
